import { parseWorkoutSegments } from "./planGenerator";
import "../CSS/workoutChart.scss";

// Garmin/intervals.icu-style workout profile: bars by duration, coloured by zone.
const ZONE_COLORS: Record<number, string> = {
  1: "#2dd4bf", 2: "#34d399", 3: "#a3e635", 4: "#facc15", 5: "#fb923c",
};

// Infer the dominant zone of a non-structured (steady) session from its text.
function inferZone(text: string): number {
  const t = text.toLowerCase();
  if (/z5|sprint|vo2|\bmax\b/.test(t)) return 5;
  if (/z4|tröskel|threshold|backe|hill/.test(t)) return 4;
  if (/z3|tempo|fartlek/.test(t)) return 3;
  if (/z1|lätt|easy|lugn|recovery|vila|återhämt/.test(t)) return 1;
  return 2; // default aerobic / long
}

export function WorkoutChart(
  { description, durationHours, name, className = "wchart" }:
  { description: string; durationHours: number; name?: string; className?: string }
) {
  let segs = parseWorkoutSegments(description);
  const segTotal = segs.reduce((s, x) => s + x.min, 0);

  // Single-block (steady) sessions render as one flat bar at the inferred zone.
  if (segs.length < 2 || segTotal <= 0) {
    const min = durationHours * 60;
    if (min <= 0) return null;
    segs = [{ min, zone: inferZone(`${name ?? ""} ${description}`) }];
  }
  const total = segs.reduce((s, x) => s + x.min, 0);
  if (total <= 0) return null;

  const W = 300, H = 80;
  let x = 0;
  return (
    <svg className={className} viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none">
      {segs.map((s, i) => {
        const w = (s.min / total) * W;
        const h = (s.zone / 5) * (H - 6) + 6; // taller = harder zone
        const rect = (
          <rect key={i} x={x} y={H - h} width={Math.max(w - 0.5, 0.5)} height={h}
            fill={ZONE_COLORS[s.zone]} opacity={0.9} rx={0.5} />
        );
        x += w;
        return rect;
      })}
    </svg>
  );
}
